import { useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styled from "styled-components";
import theme from "../styles/theme";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import Input, { InputTextArea } from "./Input";
import { StyledText } from "./Text";
import { ClickableIcon } from "./Icon";
import { useScreenClass } from "react-grid-system";
import Modal from "./Modal";
import { SaveButton } from "./PillarOverviewModify";
type KnowledgeAreaCreateType = {
  isOpen?: boolean;
  header: string;
  mode: "modify" | "create";
  setOpen: (x: boolean) => void;
  knowledgeAreaData?: {
    id: string;
    description: string;
    title: string;
    knowledge_topics: Array<{
      id: string;
      description: string;
      title: string;
    }>;
  };
  onSaveComplete: (data: any) => void;
};

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
interface SkillwInputs {
  title: string;
  description: string;
}

const KnowledgeAreaCreate = ({
  isOpen,
  setOpen,
  header,
  mode,
  knowledgeAreaData,
  onSaveComplete,
}: KnowledgeAreaCreateType): JSX.Element => {
  const screenClass = useScreenClass();
  const [openTopic, setOpenTopic] = useState<boolean>(false);
  const [count, setCount] = useState({ name: 0, description: 0 });

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm<SkillwInputs>({
    mode: "onBlur",
    defaultValues: {
      title: knowledgeAreaData ? knowledgeAreaData.title : "",
      description: knowledgeAreaData ? knowledgeAreaData.description : "",
    },
  });
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            zIndex: "999958",
          },
          content: {
            maxWidth: "500px",
            padding: "0 24px",
            color: "black",
            background: "#FFFFFF",
            border: "1px solid #E7EBEE",
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.07)",
            borderRadius: "8px",
          },
        }}
      >
        <form onSubmit={handleSubmit(onSaveComplete)}>
          <CustomFlex>
            <FlexGrow>
              <Header>{header}</Header>
            </FlexGrow>
            <ClickableIcon
              size={3.125}
              fixedWidth={false}
              color="black"
              name="close"
              onClick={() => setOpen(false)}
            />
          </CustomFlex>
          <CustomFlex
            style={{
              borderBottom: "none",
              alignItems: "flex-start",
              overflowY: "scroll",
            }}
          >
            <FlexGrow>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Title</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <Input
                    maxLength={64}
                    style={{ width: "100%" }}
                    isFullWidth
                    {...register("title", { required: true })}
                  />
                  {errors.title && (
                    <p
                      style={{
                        marginTop: 0,
                        color: theme.color.red800,
                      }}
                    >
                      This field is required
                    </p>
                  )}
                </FlexGrow>
              </CustomFlexPlain>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Description</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <FlexBox
                    space={0}
                    alignItems="start"
                    style={{ width: "100%" }}
                    direction="column"
                  >
                    <FlexGrow style={{ width: "100%" }}>
                      <Controller
                        name="description"
                        control={control}
                        render={({ field }) => (
                          <>
                            <InputTextArea
                              isFullWidth
                              style={{ minHeight: "100px", width: "100%" }}
                              // value={field.value}
                              maxLength={2048}
                              onChange={(e: any) => {
                                field.onChange(e);
                                setCount({
                                  ...count,
                                  description: e.target.value.length,
                                });
                              }}
                            />
                            <FlexGrow style={{ textAlign: "end" }}>
                              <StyledText
                                style={{ fontSize: "14px" }}
                                color={theme.color.lightBlueGray500}
                              >
                                {count.description || field.value.length}/2048
                              </StyledText>
                            </FlexGrow>
                          </>
                        )}
                      />
                      {/* <InputTextArea
                        isFullWidth
                        style={{ minHeight: "100px", width: "100%" }}
                        // onChange={e => setCount(e.target.value.length)}
                        {...register("description")}
                      /> */}
                    </FlexGrow>
                  </FlexBox>
                </FlexGrow>
              </CustomFlexPlain>
              <FlexBox>
                <FlexGrow></FlexGrow>
                <Button
                  className="reduce_opct_onhover"
                  onClick={() => setOpen(false)}
                  style={{
                    border: "2px solid #64748B",
                    padding: "8px 40px",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </Button>
                <SaveButton
                  className="reduce_opct_onhover"
                  style={{
                    padding: "8px 40px",
                    color: "white",
                  }}
                >
                  Save
                </SaveButton>
              </FlexBox>
            </FlexGrow>
          </CustomFlex>
        </form>
      </Modal>
    </>
  );
};
export default KnowledgeAreaCreate;
